import React, { memo, useMemo } from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";
import { T } from "services/lang/LanguageService";
import "./JSONObjectComparer.scss";

type JSONObjectComparerProps = {
  oldValue: string;
  newValue: string;
  leftTitle?: string;
  rightTitle?: string;
};

const JSONObjectComparer = memo(
  ({
    oldValue,
    newValue,
    rightTitle = T("label.new-code"),
    leftTitle = T("label.old-code"),
  }: JSONObjectComparerProps) => {
    const leftTitleElement = useMemo(() => <div className="middle-title">{leftTitle}</div>, [leftTitle]);
    const rightTitleElement = useMemo(() => <div className="middle-title">{rightTitle}</div>, [rightTitle]);

    return (
      <ReactDiffViewer
        oldValue={oldValue}
        newValue={newValue}
        splitView
        compareMethod={DiffMethod.LINES}
        leftTitle={leftTitleElement}
        rightTitle={rightTitleElement}
      />
    );
  }
);

JSONObjectComparer.displayName = "JSONObjectComparer";

export default JSONObjectComparer;
